import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "watchProviderTemplate",
    "watchProviderContainer",
    "releaseDateTemplate",
    "releaseContainer",
  ];

  connect() {
    // Controller connected
  }

  addWatchProvider(event) {
    event.preventDefault();
    const template = this.watchProviderTemplateTarget.content.cloneNode(true);
    const index = new Date().getTime();

    // Replace placeholder indices with unique timestamps
    template.querySelectorAll("[data-placeholder-index]").forEach((el) => {
      el.name = el.name.replace("__index__", index);
      el.id = el.id?.replace("__index__", index) || el.id;
    });

    this.watchProviderContainerTarget.appendChild(template);
  }

  removeWatchProvider(event) {
    event.preventDefault();
    const fieldset = event.target.closest(".watch-provider-fieldset");
    if (fieldset && !fieldset.classList.contains("hidden")) {
      const destroyField = fieldset.querySelector("input[name$='[_destroy]']");
      if (destroyField) {
        destroyField.value = "1";
        fieldset.classList.add("hidden");
      } else {
        fieldset.remove();
      }
    }
  }

  addReleaseDate(event) {
    event.preventDefault();
    const template = this.releaseDateTemplateTarget.content.cloneNode(true);
    const index = new Date().getTime();

    // Replace placeholder indices with unique timestamps
    template.querySelectorAll("[data-placeholder-index]").forEach((el) => {
      el.name = el.name.replace("__index__", index);
      el.id = el.id?.replace("__index__", index) || el.id;
    });

    this.releaseContainerTarget.appendChild(template);
  }

  removeReleaseDate(event) {
    event.preventDefault();
    const fieldset = event.target.closest(".release-date-fieldset");
    if (fieldset && !fieldset.classList.contains("hidden")) {
      const destroyField = fieldset.querySelector("input[name$='[_destroy]']");
      if (destroyField) {
        destroyField.value = "1";
        fieldset.classList.add("hidden");
      } else {
        fieldset.remove();
      }
    }
  }
}
